import { createApp } from "vue";
import AppComponent from "./document/app.vue";

const app = createApp(AppComponent);

export {app};
export default app;
